import { PipeTransform, Pipe } from '@angular/core';
import { QuestaoProva } from 'src/app/models/questao-prova';

@Pipe({ name: 'corAlternativaQuestao' })
export class CorAlternativaQuestaoPipe implements PipeTransform {
  transform(value: QuestaoProva, ...args: any[]) {
    return value.alternativaCorreta === args[0] ? '#00FF66' : value.alternativaSelecionada === args[0] ? '#F9BBBD' : '';
  }
}
